module.exports = __webpack_public_path__ + "static/large-tank-e425439f153982340c88c79adf98fdde.jpg";